import { Component, Input } from '@angular/core';

export interface PillConfig {
  iconLeftName?: string;
  iconLeftColor?: string;
  iconLeftSize?: number;
  iconLeftPadding?: boolean;
  iconRightName?: string;
  iconRightColor?: string;
  label: string;
  labelColor: string;
  labelStyle?: 'bold';
  backgroundColor?: string;
}

@Component({
    selector: 'bw-pill-legacy',
    templateUrl: './pill.component.html',
    styleUrls: ['./pill.component.scss'],
    standalone: false
})
export class PillComponentLegacy {
  @Input() pillConfig: PillConfig;
}
